declare namespace $ {

	export class $bog_ainews_app_favorites extends $bog_ainews_app_feed {
		title( ): string
		category_title( id: any): string
		add_post( next?: any ): any
		remove_post( next?: any ): any
		posts( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=favorite.view.tree.d.ts.map